import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<boolean>('student/SET_ONBOARDED'));
